import { storeReferralCodeInCookie } from "./referralCodeInCookie";
import { storeReferralCodeInLocalStorage } from "./referralCodeInLocalStorage";

export function storeReferralCode(referralCode) {
    // Store in cookie 
    storeReferralCodeInCookie(referralCode);

    // Store in local storage (persistent until sign-up or manual clearing)
    storeReferralCodeInLocalStorage(referralCode);
}